/**
 * This is your client vue app entrypoint
 * Its loaded because it is referenced in the vite
 * entrypoint file (index.html located at the root of this project)
 *
 * External css/js files will be loaded as dependencies.
 * You may want to check the vite configuration.
 * Some plugins will register virtual components or lazyload other for us.
 *
 * @see /index.html
 * @see /vite.config.ts
 * @see /app.ts
 * @see /app-custom.ts
 */
import * as NProgress from "nprogress";
import { createApp } from "./app";

/**
 * We create our app and mount it when it is ready
 *
 * @see /@src/app.ts for more detailed informations
 */
const addeus = createApp();

export function getApp() {
    return addeus;
}

void (async function setup() {
    /**
     * Handle NProgress display on page changes
     */
    addeus.router.beforeEach(() => {
        NProgress.start();
    });
    addeus.router.afterEach(() => {
        NProgress.done();
    });

    // wait for the app to be ready
    await addeus.router.isReady();

    // finaly mount the app to the DOM
    addeus.app.mount("#app");
})();
